import { Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/auth/ProtectedRoute';
import DashboardLayout from './components/layout/DashboardLayout';
import DashboardHome from './pages/DashboardHome';
import { Home } from './pages/Home';
import { NotFound } from './pages/NotFound';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import CompaniesPage from './pages/admin/CompaniesPage';
import SiteContentPage from './pages/admin/SiteContentPage';
import TransfersPage from './pages/admin/TransfersPage';
import ContractsPage from './pages/contracts/ContractsPage';
import ContractDashboardPage from './pages/contracts/ContractDashboardPage';
import ContractFormPage from './pages/contracts/ContractFormPage';
import ContractSignPage from './pages/contracts/ContractSignPage';
import MaintenancePage from './pages/maintenance/MaintenancePage';
import PublicSignPage from './pages/contracts/PublicSignPage';
import BillingPage from './pages/billing/BillingPage';
import CompanySettingsPage from './pages/settings/CompanySettingsPage';
import AgentsPage from './pages/settings/AgentsPage';
import PropertyListPage from './pages/properties/PropertyListPage';
import PropertyFormPage from './pages/properties/PropertyFormPage';
import CatalogPage from './pages/public/CatalogPage';
import PropertyDetailPage from './pages/public/PropertyDetailPage';
import FavoritesPage from './pages/FavoritesPage';
import MessagesPage from './pages/messages/MessagesPage';
import ConnectionsPage from './pages/settings/ConnectionsPage';
import VisitsPage from './pages/visits/VisitsPage';
import NotificationsPage from './pages/notifications/NotificationsPage';
import AnalyticsPage from './pages/analytics/AnalyticsPage';
import BrandingPage from './pages/settings/BrandingPage';
import SystemSettingsPage from './pages/admin/SystemSettingsPage';
import UsersPage from './pages/admin/UsersPage';
import PlansPage from './pages/admin/PlansPage';
import { useAuthInit } from './hooks/useAuthInit';

function App(): React.ReactElement {
  useAuthInit();

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/c/:companySlug" element={<CatalogPage />} />
      <Route path="/c/:companySlug/:propertySlug" element={<PropertyDetailPage />} />
      <Route path="/sign/:token" element={<PublicSignPage />} />

      {/* Protected routes — Dashboard */}
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardHome />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="properties" element={<PropertyListPage />} />
        <Route path="properties/new" element={<PropertyFormPage />} />
        <Route path="properties/:id/edit" element={<PropertyFormPage />} />
        <Route path="favorites" element={<FavoritesPage />} />
        <Route path="messages" element={<MessagesPage />} />
        <Route path="settings" element={<CompanySettingsPage />} />
        <Route path="settings/agents" element={<AgentsPage />} />
        <Route path="settings/connections" element={<ConnectionsPage />} />
        <Route path="visits" element={<VisitsPage />} />
        <Route path="contracts" element={<ContractsPage />} />
        <Route path="contracts/dashboard" element={<ContractDashboardPage />} />
        <Route path="contracts/new" element={<ContractFormPage />} />
        <Route path="maintenance" element={<MaintenancePage />} />
        <Route path="contracts/:id/edit" element={<ContractFormPage />} />
        <Route path="contracts/:id/sign" element={<ContractSignPage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="settings/branding" element={<BrandingPage />} />
        <Route path="admin/companies" element={<CompaniesPage />} />
        <Route path="admin/site-content" element={<SiteContentPage />} />
        <Route path="admin/transfers" element={<TransfersPage />} />
        <Route path="admin/settings" element={<SystemSettingsPage />} />
        <Route path="admin/users" element={<UsersPage />} />
        <Route path="admin/plans" element={<PlansPage />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
